import { GeneralSettingsType, SupportedColors } from './SettingsSidebar/types';
import { initialNodeDataType } from './Nodes/types';

export const initialNodeData = {
  'sensor-nfcAll': {
    label: 'Sensor-NFCAll',
    options: {
      channelSelective: true,
      splitScreen: true,
      splitScreenChannels: {
        channelOne: null,
        channelTwo: null,
      },
      combiScreen: false,
      combiScreenChannels: {
        channelOne: null,
        channelTwo: null,
      },
    },
    isValid: true,
  },
  'sensor-nfcSpecific': {
    label: 'Sensor-NFCSpecific',
    options: {
      trihow: null,
      channel: null,
      language: null,
    },
    isValid: true,
  },
  'sensor-button': {
    label: 'Sensor-Button',
    options: {
      buttons: null,
      language: null,
      subtype: 'regular',
    },
    isValid: true,
  },
  'sensor-buzzer': {
    label: 'Sensor-Buzzer',
    options: {
      buzzers: null,
      language: null,
      subtype: 'regular',
    },
    isValid: true,
  },
  'sensor-touch': {
    label: 'Sensor-Touch',
    options: {
      language: null,
    },
    isValid: true,
  },
  'action-showSingleScreen': {
    label: 'Action-ShowSingleScreen',
    options: {
      genericKey: null,
      languageSelective: false,
      loopVideo: null,
      renderOnScreen: 0,
      frameType: '',
    },
    isValid: true,
  },
  'action-startHometimer': {
    label: 'Action-StartHometimer',
    options: {},
    isValid: true,
  },
  'action-switchLanguage': {
    label: 'Action-SwitchLanguage',
    options: {
      targetLanguage: null,
    },
    isValid: true,
  },
  'action-toggleLED': {
    label: 'Action-ToggleLED',
    options: {
      leds: null,
      ramp: true,
      rampOptions: {
        brightness: 99,
        colour: SupportedColors.RED,
        duration: 100,
      },
      pulse: false,
      pulseOptions: {
        brightnessStateOne: 99,
        brightnessStateTwo: 99,
        colourStateOne: SupportedColors.RED,
        colourStateTwo: SupportedColors.BLUE,
        rampDuration: 100,
      },
      off: {
        rampDownDuration: 0,
      },
    },
    isValid: true,
  },
  'action-turnOnLED': {
    label: 'Action-TurnOnLED',
    options: {
      leds: null,
      ramp: true,
      rampOptions: {
        brightness: 99,
        colour: SupportedColors.RED,
        duration: 100,
      },
      pulse: false,
      pulseOptions: {
        brightnessStateOne: 99,
        brightnessStateTwo: 99,
        colourStateOne: SupportedColors.RED,
        colourStateTwo: SupportedColors.BLUE,
        rampDuration: 100,
      },
    },
    isValid: true,
  },
  'action-turnOffLED': {
    label: 'Action-TurnOffLED',
    options: {
      leds: null,
      rampDownDuration: 0,
    },
    isValid: true,
  },
  'action-dispatchCustomEvent': {
    label: 'Action-DispatchCustomEvent',
    options: {
      eventName: '',
      eventData: '',
    },
    isValid: true,
  },
  'action-customCode': {
    label: 'Action-CustomCode',
    options: {
      customCode: '',
    },
    isValid: true,
  },
} satisfies initialNodeDataType;

// Initial nodes for base behaviour
export const defaultBehaviourNodes = [
  {
    id: Date.now().toString(),
    type: 'sensor-nfcAll',
    position: { x: 0, y: 0 },
    deletable: false,
    data: {
      label: 'Sensor-NFCAll',
      options: {
        channelSelective: true,
        languageSelective: false,
        splitScreen: true,
        splitScreenChannels: {
          channelOne: null,
          channelTwo: null,
        },
        combiScreen: false,
        combiScreenChannels: {
          channelOne: null,
          channelTwo: null,
        },
      },
      isValid: true,
    },
  },
  {
    id: (Date.now() + 1).toString(),
    type: 'action-showSingleScreen',
    position: { x: 200, y: -50 },
    data: {
      label: 'Action-ShowSingleScreen',
      options: {
        genericKey: null,
        languageSelective: false,
        loopVideo: null,
        renderOnScreen: 0,
        frameType: '',
      },
      isValid: true,
    },
  },
  {
    id: (Date.now() + 2).toString(),
    type: 'action-startHometimer',
    position: { x: 200, y: 50 },
    data: {
      label: 'Action-StartHometimer',
      options: {},
      isValid: true,
    },
  },
];

// Initial edges for base behaviour
export const defaultBehaviourEdges = [
  {
    id: `xy-edge__${defaultBehaviourNodes[0].id}active-${defaultBehaviourNodes[1].id}`,
    source: defaultBehaviourNodes[0].id,
    target: defaultBehaviourNodes[1].id,
    sourceHandle: 'active',
  },
  {
    id: `xy-edge__${defaultBehaviourNodes[0].id}passive-${defaultBehaviourNodes[2].id}`,
    source: defaultBehaviourNodes[0].id,
    target: defaultBehaviourNodes[2].id,
    sourceHandle: 'passive',
  },
];

export const GeneralSettingsDefault: GeneralSettingsType = {
  homeTimer: 0,
  resetTimer: 600000,
  languageSelective: false,
  controllers: [],
  nfcReaders: [],
  buttons: [],
  buzzers: [],
  screens: [],
  leds: [],
  isHomeTimerDefinedInCMS: false,
  isSlideDeletionAllowed: true,
};
